module.exports = __webpack_public_path__ + "static/media/adobe-after-effects.5e394508.svg";